const UserRoles = {
  ADMIN: 'Admin',
  SUPERADMIN: 'Support Admin',
  STATEHEAD: 'State Level Head',
  DISTRICTHEAD: 'District Level Head',
  BLOCKHEAD: 'Block Level Head',
  PHCHEAD: 'PHC MO',
  ASHA: 'ASHA',
  UPHCHEAD: 'UPHC MO',
  CAM:'CAM',
  CPM:'CPM',
  MOH:'MOH',
  BCM:'BCM',
  STATECOMMISSIONER:'State Commissioner',
  JOINTDIRECTOR:'Joint Director',
  STATEASHAPO:'State ASHA PO',
  DHO:'DHO',
  DAM:'DAM',
  DCM:'DCM',
  THO:'THO',
  BFO:'BFO',
  UPHCMO:'UPHC MO',
  PHCMO:'PHC MO',
  MULTIDISTRICT:'Multi District',
  BLOCKACCOUNTANT: 'Block Accountant'
};

Object.freeze(UserRoles);

export default UserRoles;
export const ROLE_PERMISSIONS = {
  [UserRoles.ADMIN]: ['dropdown1', 'dropdown2', 'dropdown3'],
  [UserRoles.SUPERADMIN]: [],
  [UserRoles.STATEHEAD]: ['dropdown1', 'dropdown2'],
  [UserRoles.DISTRICTHEAD]: ['dropdown1', 'dropdown2'],
  [UserRoles.BLOCKHEAD]: ['dropdown1', 'dropdown2'],
  [UserRoles.PHCHEAD]: ['dropdown1', 'dropdown2'],
};
